import { render, staticRenderFns } from "./CreateRole.vue?vue&type=template&id=772f8620&"
import script from "./CreateRole.vue?vue&type=script&lang=ts&"
export * from "./CreateRole.vue?vue&type=script&lang=ts&"
import style0 from "./CreateRole.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports